/**
 * THE ROOM'S SHARED WORKSPACE (CONTEXT-DOCS.md §H1) — the same resolution the workspace browser uses (a POOL workspace
 * pinned to this room wins, else the network default) → ``{ workspaceId, scope }`` for Do outputs ('' while unknown).
 */
import { useEffect, useState } from 'react';
import { listWorkspaces } from '@stepflow/ui-shared/services/toolsApi';

export default function useRoomWorkspace(networkId, poolId, networkWorkspaceId = '') {
  const [ws, setWs] = useState({ workspaceId: '', scope: null });
  useEffect(() => {
    let gone = false;
    if (!networkId || !poolId) { setWs({ workspaceId: '', scope: null }); return undefined; }
    const fallback = () => (networkWorkspaceId
      ? { workspaceId: String(networkWorkspaceId), scope: { kind: 'NETWORK', networkId } }
      : { workspaceId: '', scope: null });
    Promise.resolve()
      .then(() => listWorkspaces({ networkId, poolId }))
      .then((res) => {
        if (gone) return;
        const rows = Array.isArray(res && res.secrets) ? res.secrets : [];
        const pool = rows.find((r) => String((r && r.scope && r.scope.kind) || '').toUpperCase() === 'POOL'
          && ((r.scope && r.scope.poolId) || '') === poolId);
        setWs(pool ? { workspaceId: pool.secretId, scope: { kind: 'POOL', networkId, poolId } } : fallback());
      })
      .catch(() => { if (!gone) setWs(fallback()); });
    return () => { gone = true; };
  }, [networkId, poolId, networkWorkspaceId]);
  return ws;
}
